import { Component } from "@angular/core";
@Component({
  selector: "gh-example-checkbox-component",
  templateUrl: "./example-checkbox.component.html",
  styleUrls: ["./example-checkbox.component.less"],
})
export class ExampleCheckboxComponent {
  public allChecked = false;
  public indeterminate = true;
  public checked = true;
  public checkOptionsOne = [
    { label: "Apple", value: "Apple", checked: true },
    { label: "Pear", value: "Pear", checked: false },
    { label: "Orange", value: "Orange", checked: false },
  ];

  public selectedArray = ["A"];

  public updateAllChecked(): void {
    this.indeterminate = false;
    if (this.allChecked) {
      this.checkOptionsOne = this.checkOptionsOne.map((item) => ({
        ...item,
        checked: true,
      }));
    } else {
      this.checkOptionsOne = this.checkOptionsOne.map((item) => ({
        ...item,
        checked: false,
      }));
    }
  }

  public updateSingleChecked(): void {
    if (this.checkOptionsOne.every((item) => !item.checked)) {
      this.allChecked = false;
      this.indeterminate = false;
    } else if (this.checkOptionsOne.every((item) => item.checked)) {
      this.allChecked = true;
      this.indeterminate = false;
    } else {
      this.indeterminate = true;
    }
  }

  public selectValues(value: string[]): void {
    this.selectedArray = value;
  }
}
